"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSetFavouriteApplicationStatusCommandHandler = void 0;
const domain_1 = require("../../domain");
const base_wishlist_command_handler_1 = require("../base-wishlist-command-handler");
class DefaultSetFavouriteApplicationStatusCommandHandler extends base_wishlist_command_handler_1.BaseWishlistCommandHandler {
    constructor(wishlistRepository, eventEmitter) {
        super(wishlistRepository);
        this.wishlistRepository = wishlistRepository;
        this.eventEmitter = eventEmitter;
    }
    validate(command) {
        if (typeof command.studyId !== 'number') {
            throw new domain_1.FavouriteInvalidStudyId(command.studyId);
        }
    }
    handle({ studyId, userId, applicationStatus, expectedState, isLocal }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.validate({ studyId, userId, applicationStatus, expectedState, isLocal });
                const wishlist = yield this.getWishlist(userId, expectedState);
                const favourite = wishlist.findFavourite(studyId);
                if (!favourite) {
                    throw new domain_1.FavouriteNotFound(wishlist.userId, studyId);
                }
                const timestamp = this.getCurrentDate();
                favourite.setApplicationStatus(applicationStatus);
                yield this.wishlistRepository.setFavouriteApplicationStatus(wishlist, studyId, applicationStatus);
                yield this.emitFavouriteApplicationStatusChanged(userId, studyId, applicationStatus, wishlist.stateHash, timestamp, isLocal);
                return {
                    resultingState: wishlist.stateHash,
                };
            }
            catch (error) {
                throw error;
            }
        });
    }
    emitFavouriteApplicationStatusChanged(userId, studyId, applicationStatus, stateHash, timestamp, isLocal) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.eventEmitter.emit(domain_1.FavouriteApplicationStatusChanged.EventType, domain_1.FavouriteApplicationStatusChanged.create(userId, studyId, applicationStatus, stateHash, timestamp, isLocal));
        });
    }
}
exports.DefaultSetFavouriteApplicationStatusCommandHandler = DefaultSetFavouriteApplicationStatusCommandHandler;
